/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type UserMenuContainer_app$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type DashboardContainer_app$ref: FragmentReference;
declare export opaque type DashboardContainer_app$fragmentType: DashboardContainer_app$ref;
export type DashboardContainer_app = {|
  +campaign: ?{|
    +isLive: boolean
  |},
  +$fragmentRefs: UserMenuContainer_app$ref,
  +$refType: DashboardContainer_app$ref,
|};
export type DashboardContainer_app$data = DashboardContainer_app;
export type DashboardContainer_app$key = {
  +$data?: DashboardContainer_app$data,
  +$fragmentRefs: DashboardContainer_app$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "DashboardContainer_app",
  "type": "App",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "campaign",
      "storageKey": null,
      "args": null,
      "concreteType": "Campaign",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "isLive",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "UserMenuContainer_app",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '400a6b77cd2106a5c392c39cffc7c0fe';
module.exports = node;
